<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="参数名称" prop="name">
							<el-input v-model="form.name" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="必填" >
							<el-switch
							  v-model="form.topping"
							  active-color="#13ce66"
							  inactive-color="#dcdfe6">
							</el-switch>
						</el-form-item>
						<el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交" >
						</el-form-item>
					</el-form>
					
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import E from "wangeditor";
	import EditorBar from '../../../components/editor.vue'
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				form: {
					name: '',
					topping:true,
				},
				formPara: {
					qq: '',
					name: '',
					detail: ''
				},
				isClear: false,
				rules: {
					name: [{
						required: true,
						message: '请输入参数名称',
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			if(this.$route.query.iden == 'update'){
				this.form.name = this.$route.query.rows.title
				this.form.topping = this.$route.query.rows.must == 1 ? true :false
				this.form.id = this.$route.query.rows.id
			}
		},
		mounted() {

		},
		methods: {
			change(val) {
				console.log(val)

			},
			//添加
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
				
						if (valid) {
							var obj = this;
							obj.$http({
								method: 'post',
								url: 'api/v1/message/param/add',
								data: {
			 
									title: this.form.name,
									must: this.form.topping == true ? 1 : 0
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功');
									this.form.title = '',
										this.form.topping == true
										this.$router.push({
											path:'/home/Mparameter'
										})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.onUpdate(formName)
				}
			},
			//修改
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this
						obj.$http({
							method: 'post',
							url: 'api/v1/message/param/update',
							data: {
		 
								title: this.form.name,
								must: this.form.topping == true ? 1 : 0,
								id:this.form.id
							},
						}).then((res) => {
							if (res.data.status == 200) {
								this.$message.success('修改成功！');
								this.$router.push({
									path:'/home/Mparameter'
								})
							} else {
								this.$message.error(res.data.message);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 30px;
	}

	/deep/ .el-input__inner {
		height: 30px !important;
	}

	/deep/ .el-form-item__label {
		width: 36px;
		height: 17px;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/message/pUpdate.vue